// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"117":"660c6ecb","210":"bdec1949","415":"88e70843","488":"e75445ad","504":"fee7e469","776":"41d4e43b"}[chunkId] + ".chunk.js";
};